import { RadioOptionsWithConfirm, PhoneNumberInput } from 'shared-components';

import QuestionPage from '../../../templates/question';
import { Q } from '../../../../store/student/types';
import { InputFieldConfig } from '../../../../types';

import { useState } from 'react';
import { savePI } from '../../../../store/student/actions';
import { createUpdatePIFieldAction } from '../../../../store/student/personalInfo/actions';
import { Pages } from '../../../../store/student/personalInfo/types';
import { useDispatch } from 'react-redux';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useTranslation } from "react-i18next";

export interface IDispatchProps {
  onNext: (config: any) => void;
  onChange: (fieldName: string, value: boolean | string | number) => void;
  onBackToTaskList: () => void;
}

export interface ICustomProps {
  sectionTitle: string;
  complete: boolean;
  currentStep: number;
  steps: number;
  useWhatsapp: string;
  whatsAppVisible: boolean;
  whatsAppConfig: InputFieldConfig;
  whatsAppPhoneNumber?: string;
  whatsAppPhoneNumberVisible: boolean;
  whatsAppPhoneNumberConfig: InputFieldConfig;
  config: any;
}

type IProps = ICustomProps;

function PersonalQPage10(props: IProps) {
    const { t } = useTranslation('common');
  const [whatsAppPhoneNumber, setWhatsAppPhoneNumber] = useState({
    code: props.whatsAppPhoneNumber ? props.whatsAppPhoneNumber.split('-')[0] : null,
    phone: props.whatsAppPhoneNumber ? props.whatsAppPhoneNumber.split('-')[1] : null,
  });
  const [isWhatsAppOtherNumberValid, setIsWhatsAppOtherNumberValid] = useState(true);

  const dispatch = useDispatch();
  const onNext = (config: any) => {
    dispatch(savePI(Pages.PAGE10, config));
  };
  const onChange = (fieldName: string, value: any) => dispatch(createUpdatePIFieldAction(fieldName, value));
  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  const handleUseWhatsAppClick = question => {
    if (question.label === 'Yes, with a different number') {
      onChange(Q.USE_WHATSAPP, 'Different');
    } else if (question.label === 'Yes, with the same number') {
      onChange(Q.USE_WHATSAPP, 'Yes');
    } else {
      onChange(Q.USE_WHATSAPP, 'No');
    }
    onChange(Q.WHATSAPP_OTHER_NUMBER, '');
    setWhatsAppPhoneNumber({ code: null, phone: null });
  };

  return (
    <QuestionPage
      complete={
        props.complete &&
        isWhatsAppOtherNumberValid &&
        (props.useWhatsapp === 'Different'
          ? whatsAppPhoneNumber.code !== null &&
            whatsAppPhoneNumber.code !== '' &&
            whatsAppPhoneNumber.phone !== null &&
            whatsAppPhoneNumber.phone !== ''
          : true)
      }
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      {props.whatsAppVisible && (
        <RadioOptionsWithConfirm
          key={Q.USE_WHATSAPP}
          id={Q.USE_WHATSAPP}
          label={t('common:doYouUseWhatsapp')}
          inputHelperText={props.whatsAppConfig?.helpText}
          autofocus={true}
          onClick={question => handleUseWhatsAppClick(question)}
          questions={[
            {
              char: '1',
              label: 'Yes, with the same number',
              selected: props.useWhatsapp === 'Yes',
            },
            {
              char: '2',
              label: 'Yes, with a different number',
              selected: props.useWhatsapp === 'Different',
            },
            {
              char: '3',
              label: 'No',
              selected: props.useWhatsapp === 'No',
            },
          ]}
        />
      )}

      {props.whatsAppPhoneNumberVisible && (
        <PhoneNumberInput
          key={Q.WHATSAPP_OTHER_NUMBER}
          id={Q.WHATSAPP_OTHER_NUMBER}
          label={t('common:otherPhoneNumber')}
          codeValue={whatsAppPhoneNumber.code ? whatsAppPhoneNumber.code : ''}
          numberValue={whatsAppPhoneNumber.phone ? whatsAppPhoneNumber.phone : ''}
          inputHelperText={props.whatsAppPhoneNumberConfig?.helpText}
          onValidationFailed={() => {
            setIsWhatsAppOtherNumberValid(false);
            onChange(Q.WHATSAPP_OTHER_NUMBER, '');
          }}
          onValidationSuccess={() => {
            const { code, phone } = whatsAppPhoneNumber;
            setIsWhatsAppOtherNumberValid(true);
            const oldCode = props.whatsAppPhoneNumber ? props.whatsAppPhoneNumber.split('-')[0] : null;
            const oldPhone = props.whatsAppPhoneNumber ? props.whatsAppPhoneNumber.split('-')[1] : null;

            if (`${oldCode || ''}-${oldPhone || ''}` !== `${code || ''}-${phone || ''}`) {
              onChange(Q.WHATSAPP_OTHER_NUMBER, `${code || ''}-${phone || ''}`);
            }
          }}
          onChangeCode={event => {
            const code = event.currentTarget.value;
            const { phone } = whatsAppPhoneNumber;
            onChange(Q.WHATSAPP_OTHER_NUMBER, `${code}-${phone}`);
            setWhatsAppPhoneNumber({ ...whatsAppPhoneNumber, code });
          }}
          onChangeNumber={event => {
            const phone = event.currentTarget.value;
            const { code } = whatsAppPhoneNumber;
            onChange(Q.WHATSAPP_OTHER_NUMBER, `${code}-${phone}`);
            setWhatsAppPhoneNumber({ ...whatsAppPhoneNumber, phone });
          }}
        />
      )}
    </QuestionPage>
  );
}

export default PersonalQPage10;
